const AboutUsApi=[
    {
        id:1,
        title:"Security",
        info: "We satisfy the highest security standards by being compliant with the Payment Card Industry Data Security Standard (PCI-DSS). Security is built into our products starting from the earliest stage."
    },
    {
        id:2,
        title:"Accept Your Money Wherever You Are!!",
        info: "OnlinePay is a fully integrated suite of payments products. Our fast, easy to use Virtual POS, Future POS lets you access your account wherever you need it. JustPay mission is to provide businesses of all sizes with the opportunity to receive online payments anywhere."
    },
    {
        id:3,
        title:"How We Helps Your Business To Grow?",
        info: "We offer customers the flexibility of remote transactions. Our VPOS is versatile and customisable solution for all your online shop needs. The integration of VPOS is possible with numerous e-commerce platforms."
    }
]

export default AboutUsApi